<template>
    <div class="create__form">
        <h1>Nýtt umræðuefni</h1>
        <hr>

        <div class="form__input">
            <label for="name">Heiti umræðu</label>
            <input id="name" v-model="name"/>
        </div>
        <div class="form__input">
            <label for="episode_nr">Þáttur númer</label>
            <input id="episode_nr" v-model="episode_nr"/>
        </div>
        <div class="form__input">
            <label for="order_by">Röðun (tala)</label>
            <input id="order_by" v-model="order_by"/>
        </div>
        <div class="form__input">
            <label for="slug">Vafravænt heiti (engin bil né ísl. stafir)</label>
            <input id="slug" v-model="slug"/>
        </div>
        <div class="form__input">
            <label for="gestur">Gestur</label>
            <input id="gestur" v-model="gestur"/>
        </div>
        <div class="form__checkbox">
            <input id="isFromStreet" type="checkbox" v-model="isFromStreet"/>
            <label for="isFromStreet">Málefni úr sal</label>
        </div>

        <div v-if="!persisted">
            <button class="save__btn" @click="persistTopic">Vista umræðu</button>
        </div>

        <div v-if="message">{{ message }}</div>

        <div v-if="persisted">
            <button class="clear__btn" @click="clearForm">Hreinsa</button>
        </div>

        <admin-footer></admin-footer>
    </div>
</template>

<script>
    import {db} from '../../main'
    import AdminFooter from './AdminFooter.vue';

    export default {
        components: {AdminFooter},
        name: 'AddTopic',
        data() {
            return {
                episode_nr: null,
                name: null,
                order_by: null,
                slug: null,
                isFromStreet: null,
                message: null,
                gestur: null,
                persisted: false,
            }
        },
        methods: {
            persistTopic(e) {
                const _this = this;

                db.collection('topics').doc(this.slug).set({
                    avarage: 0,
                    count: 0,
                    episode_nr: this.episode_nr,
                    name: this.name,
                    gestur: this.gestur,
                    order_by: this.order_by || 0,
                    isFromStreet: this.isFromStreet,
                    slug: this.slug
                })
                .then(function (docRef) {
                    _this.persisted = true;
                    _this.message = 'Umræðuefnið "' + _this.name + '" vistað';
                })
                .catch(function (error) {
                    console.error('Error adding document: ', error);
                });
            },
            clearForm(e) {
                this.episode_nr = null;
                this.name = null;
                this.order_by = null;
                this.slug = null;
                this.isFromStreet = null;
                this.message = null;
                this.gestur = null;
                this.persisted = false;
            }
        }
    }
</script>

<style scoped>

    h1 {
        font-weight: normal;
    }

    input {
        display: block;
        width: 50%;
        height: 30px;
        font-size: 1.1em;
    }

    input[type=checkbox] {
        display: inline;
        width: 20px;
        height: 14px;
    }

    .create__form {
        text-align: left;
    }

    .form__input {
        margin-bottom: 15px;
    }

    .save__btn {
        margin-top: 20px;
        background: lightgray;
        color: #222;
        border: none;
        position: relative;
        height: 40px;
        font-size: 1.1em;
        padding: 0 2em;
        cursor: pointer;
        transition: 600ms ease all;
        outline: none;
    }

    .clear__btn {
        background: lightgray;
        color: #222;
        border: none;
        position: relative;
        height: 20px;
        font-size: 1.0em;
        padding: 0 2em;
        cursor: pointer;
        transition: 600ms ease all;
        outline: none;
    }

    .save__btn:hover,
    .clear__btn:hover {
        background: #a79551;
        color: white;
    }

    .save__btn:before,
    .save__btn:after {
        content: '';
        position: absolute;
        top: 0;
        right: 0;
        height: 2px;
        width: 0;
        background: lightgray;
        transition: 400ms ease all;
    }

    .save__btn:after {
        right: inherit;
        top: inherit;
        left: 0;
        bottom: 0;
    }

    .save__btn:hover:before,
    .save__btn:hover:after {
        width: 100%;
        transition: 800ms ease all;
    }
</style>


// WEBPACK FOOTER //
// src/components/admin/AddTopic.vue